'use client';

import { buildSupportWhatsAppUrl } from '@/lib/utils/supportWhatsApp';
import { useTranslations } from 'next-intl';
import { siWhatsapp } from 'simple-icons';

/**
 * زر واتساب عائم للتواصل مع الدعم — يظهر في أسفل يمين الشاشة
 * يستخدم شعار واتساب من مكتبة simple-icons (مثل Footer)
 */
export default function FloatingWhatsAppButton() {
  const t = useTranslations('pages.campaigns');
  const tNav = useTranslations('nav');
  const platformName = tNav('brandName');
  const url = buildSupportWhatsAppUrl(t('whatsappDefaultMessage', { platformName }));

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 end-6 z-50 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition hover:scale-105 active:scale-95 sm:h-16 sm:w-16"
      style={{
        backgroundColor: '#25D366',
        color: '#fff',
        boxShadow: '0 4px 14px rgba(37, 211, 102, 0.4)',
      }}
      aria-label={t('whatsappSupport')}
    >
      <svg
        role="img"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className="h-7 w-7 shrink-0 sm:h-8 sm:w-8"
        style={{ fill: 'currentColor' }}
        aria-hidden
      >
        <path d={siWhatsapp.path} />
      </svg>
    </a>
  );
}
